import {CarouselSliceDefaultPrimaryCardsItem} from 'prismicio-types'
import {SliderSeparators} from './Separators'
import cn from 'classnames'
import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import {ButtonV2} from 'src/common/ButtonV2'
import {PrismicNextImage} from '@prismicio/next'
import {useLinkResolver} from 'prismicio'
import {LinkFieldWithText} from 'src/common/types'

const GRID_ROWS_SLIDER = 'grid-rows-[20px_auto] md:grid-rows-[38px_auto] lg:grid-rows-[64px_minmax(461px,auto)]'

const GRID_COLS =
  'grid-cols-[20px_minmax(0,1fr)_20px] md:grid-cols-[12px_1fr_12px] lg:grid-cols-[12px_minmax(0,1152px)_12px]'

export const Slide = ({
  card,
  index,
  isActive,
  sliceType,
  componentIndex,
  pageUid,
}: {
  card: CarouselSliceDefaultPrimaryCardsItem
  index: number
  componentIndex?: number
  pageUid?: string
  isActive?: boolean
  sliceType?: string
}) => {
  const {linkResolver} = useLinkResolver()

  return (
    <div className={`grid ${GRID_ROWS_SLIDER} ${GRID_COLS} w-full max-w-[1176px]`} key={index}>
      <SliderSeparators />
      <div className="col-span-1 col-start-2 row-span-1 row-start-2 ml-[-1px] mt-[-1px] flex rounded-[4px] border-[1px] border-[#345142] p-6 max-lg:flex-col max-lg:gap-6 md:p-8 lg:justify-between lg:gap-16">
        <div
          className={cn('flex h-full w-full flex-col justify-between gap-6 lg:max-w-[512px]', {
            'opacity-30 shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]': !isActive,
          })}
        >
          <div className="flex flex-col gap-3 md:gap-6 lg:gap-8">
            <div className="block h-[14px]">
              {isFilled.keyText(card.tag) && (
                <span className="text-button-s float-start mr-3 inline-block text-green-neon">{card.tag}</span>
              )}
              <div className="float-start mb-0.5 mt-[5px] inline-block h-1 w-1 rounded-[1px] bg-moss-white/[70%]" />
              {isFilled.keyText(card.category) && (
                <span className="text-button-s float-start ml-3 text-moss-white/[70%]">{card.category}</span>
              )}
            </div>
            <div className="flex flex-col gap-2 lg:gap-3">
              <PrismicRichText
                components={{
                  heading2: ({children}) => (
                    <h2 className="text-24 font-normal leading-[normal] text-moss-white md:text-32 md:font-medium md:tracking-[-.32px]">
                      {children}
                    </h2>
                  ),
                }}
                field={card.title}
              />
              <PrismicRichText
                components={{
                  paragraph: ({children}) => (
                    <p className="text-tg-body-m md:text-tg-body-l text-moss-white/[70%] max-md:max-h-[180px] max-md:overflow-hidden max-md:text-ellipsis max-md:text-16 md:leading-[26px]">
                      {children}
                    </p>
                  ),
                }}
                field={card.description}
              />
            </div>
          </div>
          {isFilled.link(card.link) && (
            <ButtonV2
              variant="primary"
              trackingData={{
                mktgId: `carousel-card-link-${index}`,
                location: `${sliceType}-${componentIndex}`,
                pageName: pageUid,
                dataType: 'link',
              }}
              href={linkResolver(card.link)}
              className="w-fit !text-wrap"
            >
              {(card.link as LinkFieldWithText).text}
            </ButtonV2>
          )}
        </div>
        <PrismicNextImage
          className={cn(
            'aspect-[335.00/273.65] w-full rounded-[4px] max-lg:-order-1 lg:float-end lg:max-w-[486px] lg:rounded-lg',
            {
              'opacity-30 shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]': !isActive,
            },
          )}
          field={card.image}
        />
      </div>
    </div>
  )
}
